import React from "react";
import { useProductSelector } from "../../stores/product/product.store";
import { ProductState } from "../../stores/product/product-state.interface";
import { ProductInterface } from "../../interfaces/product/product.interface";

interface MiniInfoProps {
    product: ProductInterface;
    showCharacteristic: () => void;
}

export const MiniInfo: React.FC<MiniInfoProps> = ({ product, showCharacteristic }) => {
    const translate = useProductSelector((state: ProductState) => state.translate);
    const attributes = product.miniInfo.length ? product.miniInfo : product.characteristics;

    return (
        <div className="grid md:gap-y-2 gap-x-4">
            { attributes.map((c, i) => <div key={ i } className="grid grid-cols-2 gap-4 mb-4">
                <span className="text-[14px] text-gray">{ c.name }</span>
                <span className="text-[14px]">{ c.value }</span>
            </div>) }
            { (attributes.length > 0) && <p onClick={() => showCharacteristic()} className="text-gray cursor-pointer">{ translate.allCharacteristics }</p> }
        </div>
    )
}